import { useParams } from 'react-router';
import { TabNav, type NavTab } from '@repo/ui/Tabs';
import { useUser } from '@repo/hooks/useUser';

import { POLICIES } from '@/lib/Authorization';

export type SwitchTab = 'overview' | 'forwarding' | 'numbers';

export const switchTabPath = (accountId: string, switchId: string, tab: SwitchTab = 'overview') =>
  `/a/${accountId}/switches/${switchId}${tab === 'overview' ? '' : `/${tab}`}`;

const SwitchTabNav = () => {
  const { accountId = '', switchId = '' } = useParams();
  const user = useUser();

  const tabs: (NavTab | null)[] = [
    { title: 'Overview', href: switchTabPath(accountId, switchId) },
    { title: 'Forwarding', href: switchTabPath(accountId, switchId, 'forwarding') },
    POLICIES['dids:index'](user)
      ? { title: 'Numbers', href: switchTabPath(accountId, switchId, 'numbers') }
      : null,
  ];

  return <TabNav tabs={tabs} />;
};

export default SwitchTabNav;
